import React, {useEffect, useState} from 'react';
import {
    Box,
    Button,
    Flex,
    Input,
    InputGroup,
    InputLeftElement,
    Spinner,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    useToast,
} from '@chakra-ui/react';
import {FaSearch} from "react-icons/fa";
import {MESSAGE} from '../../../../constants';
import {getUsers} from "../../api/getUsers";
import {format} from "date-fns";
import getPrettyUserRole from "../../../../helpers/userRole";

const RulesTable = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const toast = useToast();
    const [pagination, setPagination] = useState({
        pageNumber: 0,
        size: 5,
        orderByList: [{field: 'id', direction: 'ASCENDING'}],
    });
    const [totalPages, setTotalPages] = useState(1);


    const fetchUsers = async () => {
        setLoading(true);
        try {
            const {pageNumber, size, orderByList} = pagination;

            const response = await getUsers({
                searchTerm: searchTerm || null,
                userRoles: [],
                pageNumber,
                size,
                orderByList,
            });


            if (response?.content) {
                setUsers(response.content);
                const total = Math.ceil((response.total || 0) / size);
                setTotalPages(total);
            } else {
                setUsers([]);
                setTotalPages(1);
            }
        } catch (error) {
            toast({
                title: 'Error',
                description: MESSAGE.RULES.errorFetch,
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
            console.error('Error fetching rules:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, [pagination, searchTerm]);


    const renderTable = () => {
        if (loading) {
            return (
                <Box textAlign="center" p="4">
                    <Spinner size="lg"/>
                </Box>
            );
        }

        if (users.length === 0) {
            return (
                <Box textAlign="center" p="4">
                    No rules found.
                </Box>
            );
        }

        return (
            <Table variant="striped" size="sm">
                <Thead>
                    <Tr>
                        <Th>#</Th>
                        <Th>Nume Utilizator</Th>
                        <Th>Rol</Th>
                        <Th>Data înregistrării</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {users.map((user, index) => {
                        const role = user?.roles?.[0]?.role;
                        return (
                            <Tr key={user.id}>
                                <Td borderRadius="md"
                                    border="1px solid"
                                    borderColor="gray.200"> {pagination.pageNumber * pagination.size + index + 1}</Td>
                                <Td>{user.username || '-'}</Td>
                                <Td>{getPrettyUserRole(role)}</Td>
                                <Td>{user.timestamp ? format(user.timestamp, 'yyyy-MM-dd HH:mm') : "N/A"}</Td>
                            </Tr>
                        )
                    })}
                </Tbody>
            </Table>
        );
    };

    return (
        <>
            <Flex align="center" justifyContent="space-between" width="100%" mb="5">
                <InputGroup>
                    <InputLeftElement color="gray.500" pointerEvents="none">
                        <FaSearch></FaSearch>
                    </InputLeftElement>
                    <Input
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Căutare după CIF/nume partener, punct de lucru și categorie"
                    />
                </InputGroup>

            </Flex>
            {renderTable()}
            <Flex justify="space-between" mt="4" align="center">
                <Button
                    onClick={() =>
                        setPagination((prev) => ({
                            ...prev,
                            pageNumber: Math.max(prev.pageNumber - 1, 0),
                        }))
                    }
                    isDisabled={pagination.pageNumber === 0}
                    colorScheme="blue"
                    size="sm"
                >
                    Precedent
                </Button>
                <Text>
                    Page {pagination.pageNumber + 1} / {totalPages}
                </Text>
                <Button
                    onClick={() =>
                        setPagination((prev) => ({
                            ...prev,
                            pageNumber: Math.min(prev.pageNumber + 1, totalPages - 1),
                        }))
                    }
                    isDisabled={pagination.pageNumber + 1 >= totalPages}
                    colorScheme="blue"
                    size="sm"
                >
                    Următor
                </Button>
            </Flex>
        </>
    );
};

export default RulesTable;
